{
  "MENTIONS_LEGALES_URL": "/assets/pdf/MentionsLegalesCPxServicesv01.pdf",
  "CONDITIONS_GENERALES_URL": "/assets/pdf/CGUmesHabilitations_V0.3.pdf"
}
